import axios from '@utils/axios-client';

class ManualAPI {
    prefix = '/api/v1/Manual';

    async fetchManualPdfs(): Promise<{ fileName: string; displayName: string }[]> {
        const url = `${this.prefix}/GetAll`;
        const response = await axios.get<{ fileName: string; displayName: string }[]>(url);
        return response.data;
    }

    async downloadPdf(fileName: string): Promise<void> {
        const url = `${this.prefix}/Download?fileName=${encodeURIComponent(fileName)}`;
        const response = await axios.get(url, {
            responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    }
}

export const manualAPI = new ManualAPI();
